import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react';
import "./PersonAvatar.scss"
function PersonAvatar( props ) {
    const { onFinishTalking = () => { },
        avatar,
        name,
        jobtitle,
        speak = '',
        delayIn = 0.5,
        delayOut = 10,
    } = props;

    const avatarAlt = (props.avatarAlt !== undefined) ? props.avatarAlt : name;

    const [currentRepSpeech, setCurrentRepSpeech] = useState(speak)
    const [speek, setSpeek] = useState()

    const makeAvatarSpeak = (text, delayIn = 0.2,  delayOut = 0) => {
        let t1,t2

        t1 = setTimeout( () => {
            setCurrentRepSpeech(text)
            setSpeek('show')
        }, delayIn * 1000)
        if (delayOut > 0 ) {
            t2 =   setTimeout(() => {
                onFinishTalking()
            }, delayOut * 1000)
        }
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
        }
    }
    useEffect(() => {
        makeAvatarSpeak(speak, delayIn, delayOut)

    }, [speak])


    const markUp  = (avatarSpeech) => ({
        __html: avatarSpeech
    })
    return <div className="Launch-person-avatar-container">
            <p><span className='Launch-person-avatar-name'>{name}</span> - <span className='Launch-person-avatar-role'>{jobtitle}</span></p>
        {currentRepSpeech  && <div className={`Launch-person-avatar-bubble ${speek}`}>
            <div className={"Launch-person-avatar-bubble-speech"} dangerouslySetInnerHTML={markUp(currentRepSpeech)}>
            </div>
        </div>}

        <div className='Launch-person-avatar-img'>
            <img src={avatar}  alt={avatarAlt}/>
        </div>


    </div>
}
export default PersonAvatar;

PersonAvatar.propTypes = {
    avatar: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string
}
